import { ListSubheader } from "@material-ui/core";
import { CreateView } from "lego-gui-lib";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  DialogContentContainer,
  DialogTitleContainer,
  DialogViewContainer
} from "../../../common/dialogContainers";
import { ShowTreeBlockView } from "./components/ShowTreeBlockView";
import { treeBlockConfigurations } from "./schema";
import { TreeBlockType } from "./TreeBlockType";
import { createStyles, makeStyles, Theme } from "@material-ui/core";

const getTBlockSchema = (tBlockType: TreeBlockType) => {
  return treeBlockConfigurations[tBlockType].formSchema;
};

const getTBlockCustomAction = (tBlockType: TreeBlockType) => {
  return treeBlockConfigurations[tBlockType].formCustomAction;
};

const getInitialValues = (tBlockType: TreeBlockType) => {
  return treeBlockConfigurations[tBlockType].formInitialValues;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      borderRight: `1px solid ${theme.palette.divider}`,
      overflowY: "auto"
    },
    showViewHeader: {
      backgroundColor: `${theme.palette.background.paper}`
    }
  })
);

export const AddTreeBlockView = observer(
  ({ dataSource, tBlockType, goBackHandler, ...rest }: any) => {
    const i18n = useTranslation();

    const onGoBack = (node: any) => {
      goBackHandler(node);
    };

    const title = i18n.t("common:create", { domain: "hns:tree:block" });
    return (
      <CreateView
        initialValues={{
          type: tBlockType,
          ...getInitialValues(tBlockType)
        }}
        dataSource={dataSource.oneDataSource}
        {...rest}
        prefix={false}
        title={title}
        titleVariant={"h5"}
        fields={getTBlockSchema(tBlockType)}
        titleContainer={DialogTitleContainer}
        viewContainer={DialogViewContainer}
        contentContainer={DialogContentContainer}
        goBack={onGoBack}
      />
    );
  }
);

export const SelectedTreeBlockView = observer(
  ({ treeBlockId, tBlockType, handleRefreshBlock, ...rest }: any) => {
    const classes = useStyles();
    const i18n = useTranslation();
    const title = i18n.t("hns:tree:treeBlock:configBlock");

    return (
      <div className={classes.container}>
        <ListSubheader className={classes.showViewHeader}>
          {title}
        </ListSubheader>
        <ShowTreeBlockView
          treeBlockId={treeBlockId}
          {...rest}
          schema={getTBlockSchema(tBlockType)}
          customAction={getTBlockCustomAction(tBlockType)}
          handleRefreshBlock={handleRefreshBlock}
        />
      </div>
    );
  }
);
